import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=45b3e6bc&scoped=true"
import script from "./CourseEdit.vue?vue&type=script&lang=js"
export * from "./CourseEdit.vue?vue&type=script&lang=js"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=45b3e6bc&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3e6bc",
  null
  
)

export default component.exports